export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-links-line',
      title: 'Links Atualizados',
      desc: 'Nossa Hoobuy Spreadsheet é atualizada diariamente com os melhores links verificados pela comunidade.',
    },
    {
      icon: 'ri-star-line',
      title: 'Produtos Populares',
      desc: 'Selecionamos apenas os produtos mais bem avaliados e com maior número de vendas comprovadas.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Melhores Vendedores',
      desc: 'Trabalhamos apenas com vendedores confiáveis que oferecem produtos de alta qualidade.',
    },
    {
      icon: 'ri-chat-check-line',
      title: 'Avaliações Reais',
      desc: 'Todas as avaliações são verificadas por compradores reais que já utilizaram a planilha.',
    },
    {
      icon: 'ri-folders-line',
      title: 'Organização por Categoria',
      desc: 'Mais de 14 categorias organizadas para você encontrar exatamente o que procura rapidamente.',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Economia de Tempo',
      desc: 'Pare de perder horas procurando links. Nossa planilha concentra tudo em um só lugar.',
    },
  ];

  return (
    <section id="beneficios" className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 mb-4">
            HOOBUY / SHEET
          </span>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950">
            Por que usar a Hoobuy Spreadsheet?
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            A Hoobuy Spreadsheet permite encontrar produtos verificados rapidamente, economizando tempo e reduzindo riscos nas suas compras.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {benefits.map((item) => (
            <div
              key={item.title}
              className="group rounded-lg bg-background-50 border border-background-200/60 p-6 md:p-7 hover:border-primary-200/60 transition-all duration-300 cursor-default"
            >
              <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}